import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import ReactToPrint from "react-to-print";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import { get_all_purchases_returns } from "../../../Controllers/Purchases/Returns"

const PurchaseReturnReport = () => {
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState(null);
  const [role, setRole] = useState("");

  const headers = {
    name: "Purchase Returns",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search by return number or supplier",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: "0", label: "Date (Newest)" },
          { value: "1", label: "Date (Oldest)" },
          { value: "2", label: "Amount (High-Low)" },
          { value: "3", label: "Amount (Low-High)" },
        ],
      },
      {
        type: "filter",
        name: "supplier",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Supplier",
        api: "get-all-suppliers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
     /*  {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: "0", label: "Inactive" },
          { value: "1", label: "Active" },
        ],
      }, */
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Purchase Returns",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total Returns" },
        { value: 0, label: "Active" },
        { value: "0", label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);
  const [filters, setFilters] = useState({});

  const formdata = (data) => {
    setFilters(data);
    fetchData(data, 1);
  };

  const fetchData = async (tabledata, page = 1) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search || "",
        sort: tabledata?.sort || null,
        supplier: tabledata?.supplier || null,
        date: tabledata?.date || { start: "", end: "" },
        due_date: tabledata?.due_date || { start: "", end: "" },
        page: page,
        status: tabledata?.status || null,
        source: "dashboard_purchase_return_report"
      };

      const response = await get_all_purchases_returns(data);
      
      if (response?.status) {
        setBody(response?.data?.data || []);
        setRole(response?.data?.role || "");

        const activeCount = response?.data?.data?.filter(item => item?.status === 1)?.length || 0;
        const inactiveCount = response?.data?.data?.filter(item => item?.status === 0)?.length || 0;
        
        setHeader(prev => ({
          ...prev,
          navigate: {
            ...prev.navigate,
            total: [
              { value: response?.data?.totalCount || 0, label: "Total Returns" },
              { value: activeCount, label: "Active" },
              { value: inactiveCount, label: "Inactive" },
            ]
          }
        }));

        setLoader(false);
      } else {
        toast?.error(response?.message || "Failed to fetch purchase returns");
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message || "An error occurred");
      setLoader(false);
    }
  };


  useEffect(() => {
    fetchData({});
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);


  const downloadCSV = () => {
    console.log("Download CSV clicked");

    if (!body || body.length === 0) {
      console.log("No data available for download");
      toast.error("No data available to download");
      return;
    }

    try {
      const header = [
        "Return No", 
        "Supplier", 
        "Branch", 
        "Date", 
        "Due Date",
        "Subtotal", 
        "Discount", 
        "Tax [VAT]", 
        "Delivery", 
        "Total", 
        "Payment Status", 
        "Delivery Status",
      ];

      const rows = body.map((item) => {
        const paymentStatusMap = {
          0: "Pending",
          1: "Partially Paid",
          2: "Paid"
        };

        const deliveryStatusMap = {
          0: "Pending",
          1: "Processing",
          2: "Delivered"
        };

        const row = [
          item?.number ? `#PRT-${item.number}` : "-",
          item?.supplier?.name || "-",
          item?.branch?.name || "-",
          item?.date ? formatDateDDMMYYYY(item.date) : "-",
          item?.due_date ? formatDateDDMMYYYY(item.due_date) : "-",
          item?.subtotal?.toFixed?.(3) || "0.000",
          item?.discount?.toFixed?.(3) || "0.000",
          item?.taxamount?.toFixed?.(3) || "0.000",
          item?.delivery?.toFixed?.(3) || "0.000",
          item?.total?.toFixed?.(3) || "0.000",
          paymentStatusMap[item?.payment_status] || "Pending",
          deliveryStatusMap[item?.delivery_status] || "Pending",
        ];
        return row;
      });

      const csvContent = [header, ...rows]
        .map(row => row.map(field => `"${field}"`).join(","))
        .join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Purchase_Return_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      toast.success("CSV downloaded successfully");

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    if (!body || body.length === 0) {
      toast.error("No data available to download");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    registerCairoFont(doc);
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");

    doc.setFontSize(18);
    doc.text("Purchase Return Report", pageWidth / 2, 18, { align: "center" });

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString();
    doc.setFontSize(10);
    doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

    const tableRows = body.map((item) => {
      const paymentStatusMap = {
        0: "Pending",
        1: "Partially Paid",
        2: "Paid"
      };

      const deliveryStatusMap = {
        0: "Pending",
        1: "Processing",
        2: "Delivered"
      };

      return [
        item?.number ? `#PRT-${item.number}` : "-",
        item?.supplier?.name || "-",
        item?.branch?.name || "-",
        item?.date ? formatDateDDMMYYYY(item.date) : "-",
        item?.due_date ? formatDateDDMMYYYY(item.due_date) : "-",
        item?.subtotal?.toFixed?.(3) || "0.000",
        item?.discount?.toFixed?.(3) || "0.000",
        item?.taxamount?.toFixed?.(3) || "0.000",
        item?.delivery?.toFixed?.(3) || "0.000",
        item?.total?.toFixed?.(3) || "0.000",
        paymentStatusMap[item?.payment_status] || "Pending",
        deliveryStatusMap[item?.delivery_status] || "Pending",
      ];
    });

    autoTable(doc, {
      startY: 32,
      head: [[
        "Return No", 
        "Supplier", 
        "Branch", 
        "Date", 
        "Due Date",
        "Subtotal", 
        "Discount", 
        "Tax [VAT]", 
        "Delivery", 
        "Total", 
        "Payment Status", 
        "Delivery Status",
      ]],
      body: tableRows,
      styles: {
        font: "Cairo",
        textColor: [0, 0, 0],
        lineColor: [7, 181, 83],
        lineWidth: 0.2
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
        fillColor: false,
        lineColor: [7, 181, 83],
        lineWidth: 0.6
      },
    });

    doc.save(`Purchase_Return_Report_${formattedDate}.pdf`);
    toast.success("PDF downloaded successfully");
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="text-right flex gap-3 justify-end mt-4">
          <Button
            className="mr-2 !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
            type="primary"
            onClick={downloadCSV}
          >
            Download CSV
          </Button>

          <ReactToPrint
            trigger={() => (
              <Button
                className="mr-2 !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
                type="primary"
              >
                Download PDF
              </Button>
            )}
            content={() => componentRef}
            pageStyle={`
              @page {
                size: landscape;
                margin: 10mm;
              }
              
              @media print {
                tfoot {
                  position: static !important;
                  bottom: auto !important;
                }
                thead { 
                  display: table-header-group !important;
                }
                tfoot {
                  display: table-row-group !important;
                }
              }
              
              table, thead, tbody, tfoot, tr, th, td {
                padding: 2px !important; 
                font-size: 10px !important; 
              }
              
              th, td {
                border: 1px solid #ddd;
              }
              
              th {
                background-color: #f4f4f4;
              }
              
              @media print {
                table, thead, tbody, tfoot, tr, th, td {
                  border: 1px solid #000 !important;
                }
                
                th {
                  background-color: #f4f4f4 !important;
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                
                table {
                  width: 100% !important;
                  border-collapse: collapse !important;
                }
                
                thead, tfoot {
                  position: static !important;
                }
              }
            `}
          />
        </div>

        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white">
              <thead className="text-gray-500 sticky top-0 bg-white z-10">
                <tr>
                  <th className="border p-4">Return No</th>
                  <th className="border p-4">Supplier</th>
                  <th className="border p-4">Branch</th>
                  <th className="border p-4">Date</th>
                  <th className="border p-4">Due Date</th>
                  <th className="border p-4">Subtotal</th>
                  <th className="border p-4">Discount</th>
                  <th className="border p-4">Tax [VAT]</th>
                  <th className="border p-4">Delivery</th>
                  <th className="border p-4">Total</th>
                  <th className="border p-4">Payment Status</th>
                  <th className="border p-4">Delivery Status</th>
                </tr>
              </thead>
              <tbody>
                {body?.map((value, index) => {
                  const paymentStatusMap = {
                    0: { text: "Pending", color: "text-yellow-600" },
                    1: { text: "Partially Paid", color: "text-blue-600" },
                    2: { text: "Paid", color: "text-green-600" }
                  };

                  const deliveryStatusMap = {
                    0: { text: "Pending", color: "text-yellow-600" },
                    1: { text: "Processing", color: "text-blue-600" },
                    2: { text: "Delivered", color: "text-green-600" }
                  };

                  const journalEntryStatus = value?.accounting_entries?.status === "posted" 
                    ? { text: "Posted", color: "text-green-600", badge: "bg-green-100 text-green-800" }
                    : { text: "Not Posted", color: "text-gray-600", badge: "bg-gray-100 text-gray-800" };

                  return (
                    <tr key={value._id || index}>
                      <td className="border p-4 font-medium">#PRT {value?.number}</td>
                      <td className="border p-4">{value?.supplier?.name || "-"}</td>
                      <td className="border p-4">{value?.branch?.name || "-"}</td>
                      <td className="border p-4">
                        {value?.date ? formatDateDDMMYYYY(value.date) : "-"}
                      </td>
                      <td className="border p-4">
                        {value?.due_date ? formatDateDDMMYYYY(value.due_date) : "-"}
                      </td>
                      <td className="border p-4">
                        {value?.subtotal?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.discount?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.taxamount?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.delivery?.toFixed?.(3)}
                      </td>
                      <td className="border p-4 font-medium">
                        {value?.total?.toFixed?.(3)}
                      </td>
                      <td className={`border p-4 ${paymentStatusMap[value?.payment_status]?.color || "text-gray-600"}`}>
                        {paymentStatusMap[value?.payment_status]?.text || "Pending"}
                      </td>
                      <td className={`border p-4 ${deliveryStatusMap[value?.delivery_status]?.color || "text-gray-600"}`}>
                        {deliveryStatusMap[value?.delivery_status]?.text || "Pending"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="text-sm font-medium">
                  <td className="border p-4 font-bold" colSpan="5">Total</td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.subtotal || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.discount || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.taxamount || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.delivery || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.total || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>

      </Loadercomponent>
    </Header>
  );
};

export default PurchaseReturnReport;